/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Green_Finch_SingInputs */

const en_mild_green_finch_sing = /** @type {(inputs: Mild_Green_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select which languages this report should support. Can be changed later.`)
};

const de_mild_green_finch_sing = /** @type {(inputs: Mild_Green_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Sprachen aus, die dieser Bericht unterstützen soll. Kann später geändert werden.`)
};

/**
* | output |
* | --- |
* | "Select which languages this report should support. Can be changed later." |
*
* @param {Mild_Green_Finch_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_green_finch_sing = /** @type {((inputs?: Mild_Green_Finch_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Green_Finch_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_green_finch_sing(inputs)
	return de_mild_green_finch_sing(inputs)
});